import { render, staticRenderFns } from "./part-checkbox-with-textarea.vue?vue&type=template&id=1d5922d8&scoped=true&lang=pug"
import script from "./part-checkbox-with-textarea.vue?vue&type=script&lang=js"
export * from "./part-checkbox-with-textarea.vue?vue&type=script&lang=js"
import style0 from "./part-checkbox-with-textarea.vue?vue&type=style&index=0&id=1d5922d8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5922d8",
  null
  
)

export default component.exports